import React, { useContext, useEffect, useMemo, useState } from "react";

import { IAlertContext } from "../interfaces/alert";

export const AlertContext = React.createContext<IAlertContext | null>(null);

const ALERT_DURATION: number = 5000;

const alertInitialState: IAlertContext["alert"] = {
  message: "",
  type: "success",
};

export const AlertContextProvider = ({ children }: React.PropsWithChildren) => {
  const [alert, setAlert] = useState<IAlertContext["alert"]>(alertInitialState);

  useEffect(() => {
    const timer = setTimeout(() => setAlert(alertInitialState), ALERT_DURATION);
    return () => {
      clearTimeout(timer);
    };
  }, [alert?.message]);

  const contextValue = useMemo(() => ({ alert, setAlert }), [alert]);

  return (
    <AlertContext.Provider value={contextValue}>
      {children}
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(AlertContext);

  if (!context) {
    throw new Error("useAlert must be used within an AlertContextProvider");
  }

  return context;
};
